import { clearIrmData } from './onClearMsgPermissions';
import type { ComposeViewState } from 'owa-mail-compose-store';
import clearClassification from 'owa-mail-protection/lib/utils/classification/clearClassification';
import classifyMessage from 'owa-mail-protection/lib/utils/classification/classifyMessage';
import type MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';

export default function onToggleMessageClassification(
    viewState: ComposeViewState,
    classification: MessageClassificationType
) {
    const { protectionViewState } = viewState;
    const { classificationViewState, IRMData } = protectionViewState;
    const { messageClassification } = classificationViewState;
    const { Id } = classification;

    clearIrmData(viewState, IRMData);

    if (messageClassification?.Id === Id) {
        clearClassification(classificationViewState, viewState);
    } else {
        classifyMessage(classificationViewState, viewState, classification);
    }
}
